import React from 'react';
import { Snackbar } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

// import { Container } from './styles';

function SnackBar({open, setOpen, msgError}) {
  return (
    <Snackbar open={open} autoHideDuration={2000} onClose={() => setOpen(false)} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} >
      <Alert onClose={() => setOpen(false)} severity="error">
        {msgError}
      </Alert>
    </Snackbar>
  );
}

export default SnackBar;